import React, { useState } from "react";
import { PATHS, SAFE_CELLS, TOKENS_PER_PLAYER } from "./constants";

export default function useLudoGame(playerCount) {
  const COLORS = Object.keys(PATHS).slice(0, playerCount);

  const [tokens, setTokens] = useState(() =>
    COLORS.reduce((a, c) => {
      a[c] = Array(TOKENS_PER_PLAYER).fill(0).map(() => ({
        step: -1,
        finished: false,
      }));
      return a;
    }, {})
  );

  const [turn, setTurn] = useState(COLORS[0]);
  const [dice, setDice] = useState(null);
  const [winner, setWinner] = useState(null);

  const rollDice = () => {
    if (winner) return;
    const d = Math.floor(Math.random() * 6) + 1;
    setDice(d);
    moveAuto(d);
  };

  const moveAuto = (d) => {
    const list = tokens[turn];

    // 1️⃣ enter on 6
    if (d === 6) {
      const i = list.findIndex(t => t.step === -1);
      if (i !== -1) return moveToken(i, d);
    }

    // 2️⃣ move nearest to home
    const i = list
      .map((t, idx) => ({ ...t, idx }))
      .filter(t => t.step >= 0 && !t.finished)
      .sort((a, b) => b.step - a.step)[0]?.idx;

    if (i !== undefined) moveToken(i, d);
    else nextTurn();
  };

  const moveToken = (index, d) => {
    setTokens(prev => {
      const copy = structuredClone(prev);
      const token = copy[turn][index];
      const path = PATHS[turn];

      if (token.step === -1 && d !== 6) return prev;

      const next = token.step + d;
      if (next >= path.length) return prev;

      token.step = next;

      // Kill
      Object.keys(copy).forEach(color => {
        if (color === turn) return;
        copy[color].forEach(t => {
          if (t.step < 0 || t.finished) return;
          const pos1 = path[next].join(",");
          const pos2 = PATHS[color][t.step]?.join(",");
          if (pos1 === pos2 && !SAFE_CELLS.includes(pos1)) {
            t.step = -1;
          }
        });
      });

      if (next === path.length - 1) token.finished = true;
      if (copy[turn].every(t => t.finished)) setWinner(turn);

      return copy;
    });

    if (d !== 6) setTimeout(nextTurn, 500);
    setDice(null);
  };

  const nextTurn = () => {
    const i = COLORS.indexOf(turn);
    setTurn(COLORS[(i + 1) % COLORS.length]);
  };

  return { tokens, turn, dice, rollDice, winner };
}
